import { createErrorNotifier } from "../errorNotifier";

const errorNotifier = createErrorNotifier();

export default errorNotifier;
